export const emailDomain = (email: string): string | null => {
    const at = email.lastIndexOf('@');

    return at === -1
        ? null
        : email
              .slice(at + 1)
              .trim()
              .toLowerCase();
};

export const isVerifiedEmailDomain = (email: string, verifiedDomains: string[]): boolean => {
    const domain = emailDomain(email);

    return domain !== null && verifiedDomains.includes(domain);
};
